const getPoints = (value) => {
    if (typeof value !== 'number' && typeof value !== 'string') return 0;
    const points = Number(value);
    return Number.isFinite(points) && points >= 0 ? points : 0;
};

export const getQuizOverview = (quiz) => {
    const questions = (Array.isArray(quiz?.questions) ? quiz.questions : [])
        .filter(Boolean)
        .map((item, index) => {
            return {
                id: item.id ?? index,
                position: Number.isFinite(item.position) ? item.position : index + 1,
                content: item.title || '',
                rich: true,
                points: getPoints(item.points_possible),
                gradingNotes: typeof item.grading_notes === 'string' ? item.grading_notes : '',
                criterionIds: Array.isArray(item.criterion_ids) ? item.criterion_ids : [],
                isTimelyGraded: Boolean(item.ai_gradable),
            };
        })
        .sort((a, b) => a.position - b.position);
    const timelyQuestions = questions.filter(({ isTimelyGraded }) => isTimelyGraded);
    const lmsQuestions = questions.filter(({ isTimelyGraded }) => !isTimelyGraded);
    const sumPoints = (items) => items.reduce((total, { points }) => total + points, 0);

    return {
        title: quiz?.title || quiz?.assignment?.name || '',
        questions,
        timelyQuestions,
        lmsQuestions,
        totalPoints: sumPoints(questions),
        timelyPoints: sumPoints(timelyQuestions),
        lmsPoints: sumPoints(lmsQuestions),
    };
};
